import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { passwordPattern } from 'src/app/app.constants';
import { MustMatch } from 'src/app/utils/validators/must-match';
import { AuthNewService } from 'src/auth/services/auth-new.service';

@Component({
  selector: 'app-password-reset-form',
  templateUrl: './password-reset-form.component.html',
  styleUrls: ['./password-reset-form.component.scss']
})
export class PasswordResetFormComponent implements OnInit {

  form = this.fb.group({
    newPassword: [null, { validators: [Validators.required, Validators.pattern(passwordPattern)], updateOn: 'blur' } ],
    oldPassword: [null, Validators.required]
  }, {
    validator: MustMatch('newPassword', 'oldPassword')
  });

  constructor(private fb: UntypedFormBuilder, private auth: AuthNewService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void { }

  onSubmit() {

    if (this.form.invalid) {
      return;
    }

    this.auth.setNewPassword(this.form.value.newPassword , this.token).subscribe(
      response => this.router.navigate(['/'])
    );

  }

  get token(): string {
    return this.route.snapshot.paramMap.get('token');
  }

}
